export { DMS_MODULE } from '../constants';
export { NAME as CONTROLLER_NAME } from '../constants';
// TODO: GA - CRUMB_LABEL_KEY
export const CRUMB_LABEL_KEY = 'edtRabatsk';
export const NAME = 'MkTrida';
